const Slider = function(element) {
    this._init(element);
}

Slider.prototype = {
    _init(element) {
        this.element = element;
        this.interval = this.element.getAttribute('data-interval') || 2000;
        this.animationDuration = this.element.getAttribute('data-animation-duration') || 100;
        this.containers = [];
        const containers = element.getElementsByClassName('slider-image-container');
        for (let i = 0; i < containers.length; i++) {
            this.containers.push(containers[i]);
        }
        this.index = 0;
        this.currentMargin = 0;
        this.targetMargin = 0;
        this.step = 1000 / this.animationDuration;
        if (this.containers.length > 1) {
            setInterval(() => {this.animate();}, this.interval);
        }
    },
    animate() {
        this.index++;
        if (this.index > this.containers.length - 1) {
            this.index = 0;
        }
        this.targetMargin = -(100 * this.index);
        setTimeout(() => {
            this.doAnimate();
        }, 10);
    },
    doAnimate() {
        if (this.currentMargin < this.targetMargin) {
            this.currentMargin = this.currentMargin + this.step;
            if (this.currentMargin > this.targetMargin) {
                this.currentMargin = this.targetMargin;
            }
        } else {
            this.currentMargin = this.currentMargin - this.step;
            if (this.currentMargin < this.targetMargin) {
                this.currentMargin = this.targetMargin;
            }
        }
        this.element.style['margin-left'] = this.currentMargin + '%';
        if (this.currentMargin != this.targetMargin) {
            setTimeout(() => {
                this.doAnimate();
            }, 10);
        } else {
            const element = this.containers[0];
            const parent = element.parentNode;
            parent.removeChild(element);
            parent.appendChild(element);
            this.containers.splice(0, 1);
            this.containers.push(element);
            this.currentMargin = 0;
            this.element.style['margin-left'] = this.currentMargin + '%';
            this.index = 0;
        }
    },
}

export default Slider;